export var IdCoopTabsPositions;
(function (IdCoopTabsPositions) {
    IdCoopTabsPositions[IdCoopTabsPositions["CoopSearch"] = 0] = "CoopSearch";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopEdit"] = 0] = "CoopEdit";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopFound"] = 0] = "CoopFound";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopInfoView"] = 1] = "CoopInfoView";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopLoyalty"] = 2] = "CoopLoyalty";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopChat"] = 3] = "CoopChat";
    IdCoopTabsPositions[IdCoopTabsPositions["CoopProjects"] = 4] = "CoopProjects";
})(IdCoopTabsPositions || (IdCoopTabsPositions = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/IdCoopTabsPositions.ts
// module id = 2808
// module chunks = 3